export const WCAG_INLINE_ERROR_CLASS = 'wcag-inline-error';
export const WCAG_CANDIDATE_ERROR_CLASS = 'wcag-candidate-field-error';
export const PHONE_VALIDATION_ERROR_ID_PREFIX = 'phone-validation-error';
export const EMAIL_VALIDATION_ERROR_ID = 'email-validation-error';

export const WCAG_FORM_ID = 'new_application';

export const PRIVACY_SECTION_ID = 'privacy-acknowledgement';
export const PRIVACY_CHECKBOX_ID = 'application_privacy_acknowledgement';
export const PRIVACY_HEADING_ID = 'privacy-heading';
export const PRIVACY_ERROR_ID = 'privacy-acknowledgement-error';
export const PRIVACY_FIELD_NAME = 'application[privacy_acknowledgement]';

export const AUTOMATED_DECISION_NOTICE_SECTION_ID = 'automated-decision-notice';
export const AUTOMATED_DECISION_NOTICE_HEADING_ID = 'automated-decision-notice-heading';

export const STANDARD_EXTENSIONS = ['pdf', 'docx', 'doc', 'jpg', 'png'];
export const VIDEO_EXTENSIONS = ['mp4', 'mov', 'webm'];
export const VIDEO_MAX_SIZE = 500 * 1024 * 1024; // 500MB
export const DEFAULT_MAX_SIZE = 50 * 1024 * 1024; // 50MB
export const ACCEPTED_EXTENSIONS = [...STANDARD_EXTENSIONS, ...VIDEO_EXTENSIONS];
export const ACCEPT_ATTRIBUTE = ACCEPTED_EXTENSIONS.map((ext) => `.${ext}`).join(',');
export const ATTACHMENT_GUIDELINE_TEXT =
  'Accepted formats: PDF, DOCX, DOC, JPG, PNG, MP4, MOV, WEBM. Max size is 50MB per file, or 500MB for videos.';
